export default __webpack_public_path__ + "static/media/securepayments.78fad179.svg";